import {get} from './httpApi';
import {getUserId} from '@/utils/auth'
/*获取网络ip*/
export function videoPage(data=null){
    return get('/video/noJwt/videoPage',{
        ...data,
        userId:getUserId()
    })
}